export default __webpack_public_path__ + "static/media/05.2b4020e9.jpeg";